import Header from "./Header";
import Footer from "./Footer";
import SkipToContent from "./SkipToContent";
import ScrollToTopButton from "./ScrollToTopButton";

/**
 * Light corporate layout shell shared by all routes.
 *
 * `<main id="main-content" tabIndex={-1}>` is the focus target used by
 * the global `ScrollToTop` component for accessible route changes and
 * the `SkipToContent` keyboard shortcut.
 */
export default function Layout({ lang, children }) {
  return (
    <div
      data-testid="site-layout"
      data-lang={lang}
      className="flex flex-col min-h-screen bg-white text-[#0F1D2D]"
    >
      <SkipToContent lang={lang} />
      <Header lang={lang} />
      <main
        id="main-content"
        tabIndex={-1}
        data-testid="main-content"
        className="flex-1 pt-16 md:pt-[72px] focus:outline-none"
      >
        {children}
      </main>
      <Footer lang={lang} />
      <ScrollToTopButton lang={lang} />
    </div>
  );
}
